{
  "nl": {
    "imagePicker": {
      "title": "Afbeelding toevoegen",
      "replaceTitle": "Afbeelding vervangen",
      "searchPlaceholder": "Afbeelding zoeken...",
      "tabLabelWithCount": "{label} ({count})",
      "resultCount": "Geen resultaten | {count} resultaat | {count} resultaten",
      "resultCountCapped": "Meer dan {count} resultaten",
      "cancel": "Annuleren",
      "confirm": "Gebruiken",
      "empty": {
        "headline": "Hier zijn geen resultaten voor „{query}“",
        "subline": "Probeer een andere zoekterm"
      },
      "error": {
        "headline": "De afbeeldingen konden niet worden geladen.",
        "retry": "Opnieuw proberen"
      },
      "generate": {
        "tabLabel": "Afbeelding genereren",
        "headline": "Maak een afbeelding",
        "promptPlaceholder": "Beschrijf je afbeelding",
        "cta": "Afbeelding maken",
        "ctaRegenerate": "Afbeelding opnieuw maken",
        "generating": "Afbeelding wordt gemaakt",
        "generated": "Afbeelding gemaakt en geselecteerd",
        "resultSelect": "Gegenereerde afbeelding selecteren",
        "modelLabel": "AI-model selecteren",
        "uploadError": "De afbeelding kon niet worden overgenomen. Probeer het opnieuw.",
        "limitReached": "Je hebt je dagelijkse limiet voor AI-afbeeldingen bereikt."
      },
      "upload": {
        "tabLabel": "Upload",
        "dropTitle": "Sleep het hierheen of {select}.",
        "dropTitleSelect": "Afbeelding selecteren",
        "success": "Bestand succesvol geüpload",
        "remove": "Afbeelding verwijderen",
        "errors": {
          "wrongFormat": "Dit bestandsformaat wordt niet ondersteund. Toegestane formaten: {formats}",
          "failed": "De afbeelding kon niet worden geüpload. Probeer het opnieuw."
        }
      },
      "stock": {
        "tabLabel": "Licentievrije afbeeldingen",
        "source": "Bron:",
        "imageTypeLegend": "Afbeeldingstype",
        "categoryLimit": "Maximaal {max} categorieën tegelijk.",
        "uploadError": "De afbeelding kon niet worden overgenomen. Probeer het opnieuw.",
        "categories": {
          "nature": "Natuur",
          "animals": "Dieren",
          "research": "Onderzoek",
          "mathematics": "Wiskunde",
          "technology": "Techniek",
          "reading": "Lezen",
          "creativity": "Creativiteit",
          "music": "Muziek",
          "sports": "Sport",
          "nutrition": "Voeding",
          "classroom": "Klaslokaal",
          "teamwork": "Teamwork",
          "climate": "Klimaat",
          "space": "Ruimte",
          "summer": "Zomer",
          "spring": "Lente",
          "autumn": "Herfst",
          "winter": "Winter",
          "easter": "Pasen",
          "christmas": "Kerstmis"
        }
      },
      "library": {
        "tabLabel": "Mijn opslag",
        "selectError": "De afbeelding kon niet worden overgenomen. Probeer het opnieuw.",
        "imageAlt": {
          "manual": "Geüploade afbeelding",
          "ai": "Met AI gemaakte afbeelding"
        },
        "empty": {
          "headline": "Je hebt nog geen afbeeldingen",
          "subline": "Je geüploade en met AI gemaakte afbeeldingen verschijnen hier."
        }
      }
    }
  }
}
